const { withStyles, Avatar } = require("@material-ui/core");

const SmallAvatar = withStyles((theme) => ({
  root: props => ({
    width: theme.spacing((props.size/8)) || theme.spacing(1.5),
    height: theme.spacing((props.size/8)) || theme.spacing(1.5),
  }),
}))(Avatar);

export default SmallAvatar;